module.exports = __webpack_public_path__ + "img/title-2.6554d8a9.png";